<template>
  <div class="vod-notice-popup">
    <div class="customer-noti-detail">
      <ul>
        <li>
          <span class="cus-list-btn">
              <span class="cus-preview">
                <strong>{{title}}</strong>
                <span class="cus-list-date">{{noticeDate}}</span>
              </span>
          </span>
          <span class="content" v-html="description"></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'ApolloPlayerNoticePopup',
  components: {
  },
  data () {
    return {
      noticeItem: {}
    }
  },
  props: {
    noticeList: {
      type: Array
    }
  },
  computed: {
    title () {
      return get(this.noticeItem, 'title', '')
    },
    noticeDate () {
      return get(this.noticeItem, 'noticedate', '')
    },
    description () {
      return get(this.noticeItem, 'description', '').replace(/\n/gi, '<br>')
    }
  },
  methods: {
    closeNoticePopup () {
      this.$router.back()
    }
  },
  created () {
    const idx = get(this.$route, 'query.noticeIdx', 0)
    this.noticeItem = get(this.noticeList, idx, {})
  }
}
</script>
<style scoped>
.vod-notice-popup{
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}

.vod-notice-popup .common-header,
.vod-notice-popup .customer-noti-detail {
  background-color: #1b1b1b;
}

.vod-notice-popup .customer-noti-detail {
  min-height: auto;
  flex: 1;
}

.vod-notice-popup .customer-noti-detail .cus-list-btn{
  padding: 12px 0;
  border: 0 none;
}

.vod-notice-popup .customer-noti-detail .cus-preview strong{
  font-size: 16px;
}

.vod-notice-popup .cus-list-date{
  line-height: 18px;
}

.vod-notice-popup .content{
  padding: 20px 0;
}

/* tablet */
@media all and (min-width: 768px) and (max-width: 1366px) {
  .vod-notice-popup .common-header,
  .vod-notice-popup .customer-noti-detail {
    width: 540px;
    margin: 0 auto;
  }
}
</style>
